import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import { request } from '@/api/service';
export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      show_operation: false,
      api: {
        index: 'MARKET_ALL',
        delete: 'MARKET_DELETE',
        sync: 'MARKET_SYNC'
      },
      permission: {
        query: '',
        add: 'market:add',
        edit: 'market:edit',
        detail: '',
        remove: 'market:remove',
        device: '',
        market_service_config: 'market-service-config',
        sync_info: 'market:sync',
        sync_bill: 'market:sync',
        sync_config: 'market:sync',
        sms_recharge: 'sms-recharge',
        market_admin: 'market-admin',
        sms_model_config: 'sms-model-config',
        sms_config: 'sms-config',
        sms_market: 'sms-market',
        sms_recharge_config: 'sms-recharge-config',
        market_pay_config: 'market-pay-config',
        charge_configs: 'charge-configs',
        market_account: 'market-account'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, // { prop: 'p_id', label: 'p_id', minWidth: '100px' },
      {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        minWidth: '100px'
      }, // { prop: 'market_password', label: 'market_password', minWidth: '100px' },
      // { prop: 'secret', label: 'secret', minWidth: '100px' },
      {
        prop: 'market_status',
        label: this.$t('market_status'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "market_status",
              "value": parseInt(row.market_status)
            }
          });
        }
      }, {
        prop: 'user_name',
        label: this.$t('user_name'),
        minWidth: '100px'
      }, // { prop: 'head_photo_url', label: 'head_photo_url', minWidth: '100px' },
      {
        prop: 'company',
        label: this.$t('company'),
        minWidth: '100px'
      }, {
        prop: 'national_area',
        label: this.$t('national_area'),
        minWidth: '100px'
      }, {
        prop: 'national_name',
        label: this.$t('national_name'),
        minWidth: '100px'
      }, {
        prop: 'is_retrieve',
        label: this.$t('is_retrieve'),
        minWidth: '100px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "is_retrieve",
              "value": row.is_retrieve
            }
          });
        }
      }, // { prop: 'company_address', label: 'company_address', minWidth: '100px' },
      // { prop: 'industry', label: 'industry', minWidth: '100px' },
      {
        prop: 'last_login_time',
        label: this.$t('last_login_time'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.last_login_time, 'YYYY/M/D HH:mm:ss');
        }
      }, // { prop: 'home_page', label: 'home_page', minWidth: '100px' },
      {
        prop: 'balance',
        label: this.$t('balance'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return row.balance ? row.balance / 100 : '0';
        }
      }, // { prop: 'balance', label: 'balance', minWidth: '100px', render: ({ row }) => <d2-dict name="table_market_balance" value={ row.id ? row.id : 0 } custom /> },
      {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'uptime',
        label: this.$t('uptime'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss');
        }
      } // { prop: 'del_flag', label: 'del_flag', minWidth: '100px', render: ({ row }) => <d2-dict name="del_flag" value={ row.del_flag }/> },
      ].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref3) {
        var row = _ref3.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          width: '100px',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('device', [{
          icon: 'el-icon-monitor',
          label: _this2.$t('device'),
          action: function action() {
            return _this2.goDeviceData(row.market_mobile);
          }
        }], [])), _toConsumableArray(_this2.show_operation ? _this2.p('market_service_config', [{
          icon: 'el-icon-setting',
          label: _this2.$t('market-service-config'),
          action: function action() {
            return _this2.goMarketServiceConfigData(row.market_mobile, row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_info', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync info'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_info'),
          action: function action() {
            return _this2.sync({
              'market_id': row.id,
              'optype': 'qr'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_bill', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync bill'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_bill'),
          action: function action() {
            return _this2.sync({
              'market_id': row.id,
              'optype': 'ad'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_config', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync config'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_config'),
          action: function action() {
            return _this2.sync({
              'market_id': row.id,
              'optype': 'confignotice'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sms_recharge', [{
          icon: 'el-icon-collection',
          label: _this2.$t('sms-recharge'),
          action: function action() {
            return _this2.goSmsRecharge(row.market_mobile);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('market_admin', [{
          icon: 'el-icon-user',
          label: _this2.$t('market-admin'),
          action: function action() {
            return _this2.goMarketAdmin(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sms_model_config', [{
          icon: 'el-icon-message',
          label: _this2.$t('sms-model-config'),
          action: function action() {
            return _this2.goSmsModelConfig(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sms_config', [{
          icon: 'el-icon-message',
          label: _this2.$t('sms-config'),
          action: function action() {
            return _this2.goSmsConfig(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sms_market', [{
          icon: 'el-icon-message',
          label: _this2.$t('sms-market'),
          action: function action() {
            return _this2.goSmsMarket(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sms_recharge_config', [{
          icon: 'el-icon-message',
          label: _this2.$t('sms-recharge-config'),
          action: function action() {
            return _this2.goSmsRechargeConfig(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('market_pay_config', [{
          icon: 'el-icon-sell',
          label: _this2.$t('market-pay-config'),
          action: function action() {
            return _this2.goMarketPayConfig(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('charge_configs', [{
          icon: 'el-icon-sell',
          label: _this2.$t('charge-configs'),
          action: function action() {
            return _this2.goChargeConfigsData(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('market_account', [{
          icon: 'el-icon-collection',
          label: _this2.$t('market-account'),
          action: function action() {
            return _this2.goMarketAccount(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? [{
          icon: 'el-icon-collection',
          label: _this2.$t('hide'),
          action: function action() {
            return _this2.hide();
          }
        }] : [{
          icon: 'el-icon-collection',
          label: _this2.$t('show'),
          action: function action() {
            return _this2.show();
          }
        }]));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    goAdminData: function goAdminData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-courier-user';
      });
      this.$router.push({
        name: 'management-courier-user',
        query: {
          market_id: market_id
        }
      });
    },
    goDeviceData: function goDeviceData(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'management-device';
      });
      this.$router.push({
        name: 'management-device',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goChargeConfigsData: function goChargeConfigsData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-charge-configs';
      });
      this.$router.push({
        name: 'management-charge-configs',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketServiceConfigData: function goMarketServiceConfigData(market_mobile, market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-service-config';
      });
      this.$router.push({
        name: 'management-market-service-config',
        query: {
          market_mobile: market_mobile,
          market_id: market_id
        }
      });
    },
    goRechargeConfigData: function goRechargeConfigData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-recharge-config';
      });
      this.$router.push({
        name: 'management-wash-recharge-config',
        query: {
          market_id: market_id
        }
      });
    },
    goAppointTimeData: function goAppointTimeData(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-wash-appoint-time';
      });
      this.$router.push({
        name: 'management-wash-appoint-time',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsRecharge: function goSmsRecharge(market_mobile) {
      this.closeBy(function (page) {
        return page.name === 'sms-recharge';
      });
      this.$router.push({
        name: 'sms-recharge',
        query: {
          market_mobile: market_mobile
        }
      });
    },
    goMarketAdmin: function goMarketAdmin(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-admin';
      });
      this.$router.push({
        name: 'management-market-admin',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsModelConfig: function goSmsModelConfig(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-model-config';
      });
      this.$router.push({
        name: 'management-sms-model-config',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsConfig: function goSmsConfig(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-config';
      });
      this.$router.push({
        name: 'management-sms-config',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsMarket: function goSmsMarket(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-market';
      });
      this.$router.push({
        name: 'management-sms-market',
        query: {
          market_id: market_id
        }
      });
    },
    goSmsRechargeConfig: function goSmsRechargeConfig(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-sms-recharge-config';
      });
      this.$router.push({
        name: 'management-sms-recharge-config',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketPayConfig: function goMarketPayConfig(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-pay-config';
      });
      this.$router.push({
        name: 'management-market-pay-config',
        query: {
          market_id: market_id
        }
      });
    },
    goMarketAccount: function goMarketAccount(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-market-account';
      });
      this.$router.push({
        name: 'management-market-account',
        query: {
          market_id: market_id
        }
      });
    },
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'table_market_balance',
        method: this.$api.MARKET_ACCOUNT_ALL,
        fields: 'market_id,balance',
        query: {
          'market_id': utils.cookies.get('market_id')
        },
        path: 'list',
        label: 'balance',
        value: 'market_id'
      });
      request({
        method: 'post',
        url: '/api/market/index',
        data: {}
      }).then(function (res) {
        console.log(res.list[0].market_mobile);

        if (res.list.length == 1) {
          utils.cookies.set('phone', res.list[0].market_mobile);
        }
      });
    },
    show: function show() {
      if (this.show_operation) {
        this.show_operation = false;
      } else {
        this.show_operation = true;
      }
    },
    hide: function hide() {
      if (this.show_operation) {
        this.show_operation = false;
      } else {
        this.show_operation = true;
      }
    }
  })
};